import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Valtech Custom Code */
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";

interface OwnProps extends WidgetProps {
    labelPosition?: "top" | "left";
}
/* Valtech Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    pagination: getProductListDataViewProperty(state, "pagination"),
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps; // Valtech Custom Code

export interface ProductListSortSelectStyles {
    select?: SelectPresentationProps;
}

export const sortSelectStyles: ProductListSortSelectStyles = {
    select: {
        sizeVariant: "smallSelect" as any,
        labelProps: {
            css: css`
                width: unset;
                font-size: ${TYPOGRAPHY.size.smallest};
                overflow: visible;

                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [{ values: ["0", null, "11px 8px 0 13px"], properties: ["padding"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        cssOverrides: {
            formField: css`
                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            { values: ["18px", null, "0"], properties: ["padding-top"] },
                            { values: ["100%", null, "auto"], properties: ["width"] },
                        ],
                        mediaOptions.min,
                    )}
            `,
            formInputWrapper: css`
                width: auto;
            `,
            inputSelect: css`
                ${props => props.theme.formField?.defaultProps?.cssOverrides?.inputSelect}
                font-size: ${TYPOGRAPHY.size.smallest};
                font-weight: ${TYPOGRAPHY.weight.bold};
            `,
        },
    },
};

const styles = sortSelectStyles;

const ProductListSortSelect = ({
    addProductFilters,
    pagination,
    // Valtech Custom Code
    labelPosition = "left",
}: Props) => {
    if (!pagination) {
        return null;
    }

    const onChangeSortHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        addProductFilters({ sort: event.currentTarget.value });
    };

    return (
        <Select
            {...styles.select}
            label={translate("Sort by")}
            value={pagination.sortType}
            labelPosition={labelPosition /* Valtech Custom Code */}
            onChange={onChangeSortHandler}
            data-test-selector="productListSortSelect"
        >
            {pagination.sortOptions.map(sortOption => (
                <option key={sortOption.sortType} value={sortOption.sortType}>
                    {sortOption.displayName}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListSortSelect),
    definition: {
        group: "Product List",
        displayName: "Sort Select",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
